import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import Spinner from "../../../theme/Spinner";
import {
  getCompanyListApi,
  updateCompanyStatusApi,
} from "../../../services/super-admin-service/_company";
import moment from "moment";
import UpdatePassword from "../user/UpdatePassword";
import { errorToast, successToast } from "../../../components/Toast";
import { DateRangePicker } from "rsuite";
import "rsuite/DateRangePicker/styles/index.css";

const CompanyList = () => {
  const [displayFilter, setDisplayFilter] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [sortKey, setSortKey] = useState<string>("");
  const [sortType, setSortType] = useState<string>("");
  const [records, setRecords] = useState([]);
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const [updatePasswordId, setUpdatePasswordId] = useState<string>("");
  const [updatePasswordEmail, setUpdatePasswordEmail] = useState<string>("");
  const [searchFilter, setSearchValue] = useState<string>("");
  const [filterStatus, setFilterStatus] = useState<string>("");
  const [dateRange, setDateRange] = useState(null);
  const [updatePasswordComapnyId, setUpdatePasswordComapnyId] =
    useState<string>("");
  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const toggleFilter = async () => {
    setDisplayFilter(!displayFilter);
  };

  const getCompanyList = async (
    page: number,
    perPage: number,
    isFilter?: boolean,
    sortKey?: string,
    sortType?: string
  ) => {
    setLoading(true);
    let query = `page=${page}&per_page=${perPage}`;
    if (isFilter) {
      if (searchFilter) {
        query += `&search=${searchFilter}`;
      }
      if (sortKey && sortType) {
        query += `&sort_key=${sortKey}&sort_type=${sortType}`;
      }
      if (filterStatus) {
        query += `&companystatus=${filterStatus}`;
      }
      if (dateRange) {
        query += `&from_date=${moment(dateRange[0]).format("YYYY-MM-DD")}`;
        query += `&to_date=${moment(dateRange[1]).format("YYYY-MM-DD")}`;
      }
    }
    const result: any = await getCompanyListApi(query);

    if (result.isSuccess) {
      const totalPagesCount = Math.ceil(result.data.total_records / perPage);
      setTotalRecords(result.data.total_records);
      setTotalPages(totalPagesCount);
      setRecords(result.data.records);
    }
    setLoading(false);
  };

  const sortTable = async (key: string) => {
    let type = sortType === "asc" ? "desc" : "asc";
    if (sortKey !== key) {
      type = "asc";
    }
    setSortKey(key);
    setSortType(type);
    await getCompanyList(page, perPage, true, key, type);
  };

  useEffect(() => {
    if (page && perPage) {
      getCompanyList(page, perPage, applyFilter);
    }
  }, [page, perPage, applyFilter]);

  const updateComapnyStatus = async (status: boolean, companyId: string) => {
    setLoading(true);
    const result: any = await updateCompanyStatusApi({
      status: !status,
      companyId: companyId,
    });
    if (result.isSuccess) {
      successToast(result.message);
      getCompanyList(page, perPage, true);
    } else {
      errorToast(result.message);
    }
    setLoading(false);
  };

  const filterList = async () => {
    setApplyFilter(true);
    setPage(1);
    getCompanyList(1, perPage, true);
  };

  const resetList = async () => {
    setPage(1);
    setApplyFilter(false);
    setFilterStatus("");
    setDateRange(null);
    setSearchValue("");
    getCompanyList(page, perPage);
  };

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>Company List</h5>
          </div>

          <div>
            <Link
              to="#"
              type="button"
              className="btn btn-label-github"
              style={{ marginRight: "15px" }}
              onClick={toggleFilter}
            >
              <span>
                <i className="ti ti-filter me-sm-1"></i>
                <span className="d-none d-sm-inline-block">Filter</span>
              </span>
            </Link>
            <Link
              className="btn btn-primary waves-effect waves-light"
              type="button"
              to="/super-admin/create-company"
            >
              <span>
                <i className="ti ti-plus me-sm-1"></i>
                <span className="d-none d-sm-inline-block">Add Company</span>
              </span>
            </Link>
          </div>
        </div>
        {displayFilter && (
          <div className="card-body">
            <form className="dt_adv_search">
              <div className="row">
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label
                        htmlFor="date"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Created AT:
                      </label>
                      <DateRangePicker
                        format="dd-MM-yyyy"
                        className="form-control"
                        placeholder="From Date ~ To Date"
                        value={dateRange}
                        onChange={(values: any) => {
                          setDateRange(values);
                        }}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label
                        htmlFor="status"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Status:
                      </label>
                      <select
                        className="form-select"
                        id="status"
                        value={filterStatus}
                        onChange={(e) => {
                          if (e.target.value) {
                            setFilterStatus(e.target.value);
                          }
                        }}
                      >
                        <option defaultChecked value="">
                          Select Status
                        </option>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </select>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label
                        htmlFor="search"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Search :
                      </label>
                      <input
                        type="text"
                        id="search"
                        className="form-control"
                        placeholder="Search..."
                        value={searchFilter}
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                    </div>
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={filterList}
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-github ms-5"
                        onClick={resetList}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}

        <div className="card-datatable table-responsive">
          {loading && <Spinner isFullScreen={false} />}
          <table className="dt-advanced-search table table-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("companyName")}
                >
                  Company Name
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("adminName")}
                >
                  Admin name
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("adminEmail")}
                >
                  Admin Email
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("status")}
                >
                  Status
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>

                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("companyCreatedAt")}
                >
                  Created At
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                records.map((item: any, i: number) => (
                  <tr key={item.id}>
                    <td>{(page - 1) * perPage + 1 + i}</td>
                    <td>{item.companyName ? item.companyName : "-"}</td>
                    <td>{item.name ? item.name : "-"}</td>
                    <td>{item.email ? item.email : "-"}</td>
                    <td>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="status"
                          defaultChecked={item.companyStatus ? true : false}
                          onClick={() => {
                            updateComapnyStatus(
                              item.companyStatus,
                              item.companyId
                            );
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      {item?.createdAt
                        ? moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")
                        : "-"}
                    </td>
                    <td>
                      <>
                        <Link
                          to={`/super-admin/edit-company/${item.id}`}
                          className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                          title="Edit Comapny"
                        >
                          <i className="ti ti-pencil ti-md"></i>
                        </Link>
                        <Link
                          to={"#"}
                          className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                          title="Change Password"
                          data-bs-toggle="modal"
                          data-bs-target="#updateUserPassword"
                          onClick={() => {
                            setUpdatePasswordId(item.id);
                            setUpdatePasswordEmail(item.email);
                            setUpdatePasswordComapnyId(item.companyId);
                          }}
                        >
                          <i className="ti ti-lock ti-md"></i>
                        </Link>
                      </>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <UpdatePassword
          id={updatePasswordId}
          email={updatePasswordEmail}
          companyId={updatePasswordComapnyId}
        ></UpdatePassword>

        <Pagination
          page={page}
          perPage={perPage}
          totalRecords={totalRecords}
          totalPages={totalPages}
          records={records}
          prevButton={prevButton}
          nextButton={nextButton}
        />
      </div>
    </>
  );
};
export default CompanyList;
